// @flow
import React from 'react';
import type { SvgComponentProps } from '~/core/icons/svg-icons/types';

const Shop = ({ fill, svgComponents: { G, Path } }: SvgComponentProps) => {
    const gProps = fill ? { fill } : {};
    return (
        <G {...gProps}>
            <Path d="M32,36H8a.5.5,0,0,1-.49-.4L4,17.6A.5.5,0,0,1,4.5,17h31a.5.5,0,0,1,.49.6l-3.5,18A.5.5,0,0,1,32,36ZM8.41,35H31.59l3.31-17H5.11Z" />
            <Path d="M25,17.5H24v-7c0-3-1.79-5.5-4-5.5s-4,2.47-4,5.5v7H15v-7C15,6.92,17.24,4,20,4s5,2.92,5,6.5Z" />
        </G>
    );
};

export default Shop;



// WEBPACK FOOTER //
// ./src/core/icons/svg-icons/general/shop/index.js